import React, { useState } from "react";
import "./styles.css";
import { db } from "../../assets/firebase/firebaseconfig";
import { ref, push } from "firebase/database";
import ReactQuill from "react-quill-new"; // Dùng bản NEW
import "react-quill-new/dist/quill.snow.css"; // Import CSS của bản NEW
import { Helmet } from "react-helmet-async";
const Contact = () => {
  const [formData, setFormData] = useState({
    username: "",
    phone: "",
    email: "",
    service: "",
    request: "",
  });
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["clean"],
    ],
  };
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Đẩy dữ liệu lên nhánh 'contacts' để trang Admin nhận được
      await push(ref(db, "contacts"), {
        ...formData,
        createdAt: Date.now(), // Lưu thời gian để Admin sắp xếp
      });

      alert("Gửi yêu cầu thành công! Chúng tôi sẽ liên hệ lại sớm.");

      // Reset form sau khi gửi
      setFormData({
        username: "",
        phone: "",
        email: "",
        service: "",
        request: "",
      });
    } catch (error) {
      console.error("Lỗi gửi liên hệ:", error);
      alert("Có lỗi xảy ra, vui lòng thử lại sau.");
    } finally {
      setLoading(false);
    }
  };
  const mapEmbedUrl =
    "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d7453.924549012556!2d105.90270159999997!3d20.91383740000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1svi!2s!4v1765553662260!5m2!1svi!2s"; // Thay mã này
  return (
    <div className="contact-wrapper">
      <Helmet>
    <title key="Lien-he">Liên Hệ Habako M&E | Tư Vấn Giải Pháp 24/7</title>
    <meta name="description" content="Kết nối với Habako M&E để nhận tư vấn kỹ thuật và báo giá thiết bị cơ điện nhanh nhất." />
  </Helmet>
      <div className="container">
        <div className="contact-grid">
          {}
          <div className="contact-info">
            <h2 className="contact-heading">LIÊN HỆ VỚI CHÚNG TÔI</h2>
            <p className="contact-sub">
              Hãy để lại thông tin, đội ngũ kỹ thuật của Habako sẽ tư vấn giải
              pháp tối ưu nhất cho bạn.
            </p>

            <div className="info-item">
              <div className="icon-box">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <div>
                <h4>Địa chỉ trụ sở:</h4>
                <p>Thôn 3, Xã Nam Phù, Thành Phố Hà Nội, Việt Nam</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-box">
                <i className="fas fa-phone-alt"></i>
              </div>
              <div>
                <h4>Hotline hỗ trợ 24/7:</h4>
                <p className="highlight">123456789</p>
              </div>
            </div>

            <div className="info-item">
              <div className="icon-box">
                <i className="fas fa-envelope"></i>
              </div>
              <div>
                <h4>Email báo giá:</h4>
                <p>contact@habako.vn</p>
              </div>
            </div>

            <div className="social-connect">
              <h4>Kết nối với Habako:</h4>
              <div className="social-icons">
                <a href="#">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#">
                  <i className="fab fa-zalo">Z</i>
                </a>
                <a href="#">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
          </div>

          {}
          <div className="contact-form-card">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Họ và tên *</label>
                <input
                  type="text"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  placeholder="Nguyễn Văn "
                />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label>Số điện thoại *</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="09xxxxxxxx"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email (nếu có)</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="email@gmail.com"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Dịch vụ quan tâm</label>
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Chọn dịch vụ</option>
                  <option value="Tư vấn lắp đặt điều hòa">
                    Tư vấn lắp đặt điều hòa
                  </option>
                  <option value="Bảo trì hệ thống HVAC">
                    Bảo trì hệ thống HVAC
                  </option>
                  <option value="Thi công kho lạnh">Thi công kho lạnh</option>
                  <option value="">Khác</option>
                </select>
              </div>
              <div className="form-group">
                <label>Nội dung yêu cầu</label>
                <textarea
                  name="request"
                  value={formData.request}
                  onChange={handleChange}
                  rows="5"
                  className="form-textarea"
                  required
                  placeholder="Hãy cho tôi biết yêu cầu của bạn là gì..."
                ></textarea>
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-submit-contact"
                style={{
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.6 : 1,
                }}
              >
                {loading ? "ĐANG GỬI..." : "GỬI YÊU CẦU NGAY"}
              </button>
            </form>
          </div>
        </div>

        {}
        <div className="contact-map">
          <iframe
            src={mapEmbedUrl}
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
